import React, { useState } from "react";
import { CharacterHelpers, LocalCharacterInitializer } from "../../../../../../entities/characters/Character";
import { ThemedButton } from "../../../../../inputs/buttons/ThemedButton";
import { MinionListing } from "./MinionListing";
import { MinionPicker } from "./MinionPicker";
import { BreakdownWindow } from "../../../../../theming/breakdown-window";
import { MinionPreview } from "./MinionPreview";
import { MinionPreviewHeader } from "./MinionPreviewHeader";
import { useAppDispatch, useAppSelector } from "../../../../../../store/configureStore";
import { OwnedMinionReference } from "../../../../../../entities/Ownership";
import { CharacterMinionActions } from "../../../../../../store/stores/collection/characters/actions/CharacterMinionActions";

type Props = {
    character: LocalCharacterInitializer;
    references: OwnedMinionReference[];
}

export const HordeComponent = (props: Props) => {
    const { character, references } = props;
    const minions = useAppSelector(app => app.library.minions);

    const [showPicker, setPickerVisibility] = useState(false);
    const [previewMinionInstanceId, setPreviewMinionInstanceId] = useState<string | null>(null);
    const dispatch = useAppDispatch();
    const close = () => setPreviewMinionInstanceId(null);
    const previewMinion = character.minions.find(m => m.instanceId == previewMinionInstanceId);
    const removeMinion = () => {
        const previewMinion = character.minions.find(m => m.instanceId == previewMinionInstanceId);
        if (previewMinion == null) {
            return;
        }
        dispatch(CharacterMinionActions.removeMinion(character, previewMinion));
        close();
    }
    return (
        <>
            <ThemedButton onClick={() => setPickerVisibility(true)}
                disabled={references.length >= CharacterHelpers.getMaxHordeSize(character)}>
                Add Minion
            </ThemedButton>
            {references.map(ref => {
                const minion = minions.find(m => m.id == ref.id);
                if (minion == null) {
                    console.error("Minion not found.");
                    return null;
                }
                return <MinionListing key={ref.instanceId} reference={ref} character={character} onClick={() => setPreviewMinionInstanceId(ref.instanceId)} />;
            })}

            <MinionPicker character={character} visible={showPicker} close={() => setPickerVisibility(false)} />

            {previewMinion &&
                <BreakdownWindow heading={<MinionPreviewHeader character={character} reference={previewMinion} />} close={close}>
                    <MinionPreview character={character} minionId={previewMinion.id} expanded />
                    <ThemedButton onClick={removeMinion}>
                        Remove Minion
                    </ThemedButton>
                </BreakdownWindow>
            }
        </>
    );
}